import { put, call, takeLatest } from 'redux-saga/effects'
import {
  ACTION_TYPES,
  getMaritalStatusOptionsSuccess,
  getMaritalStatusOptionsError
} from 'store/reducers/maritalStatusOptions'

import { getMaritalStatusOptions as getMaritalStatusOptionsService } from 'services'

const { MARITAL_STATUS_LIST_REQUEST } = ACTION_TYPES

export function *getMaritalStatusOptions() {
  try {
    const response = yield call(getMaritalStatusOptionsService)
    yield put(getMaritalStatusOptionsSuccess(response))
  } catch (err) {
    yield put(getMaritalStatusOptionsError())
  }
}
export default function *watchMaritalStatusOptions() {
  yield takeLatest(MARITAL_STATUS_LIST_REQUEST, getMaritalStatusOptions)
}
